import { useLegacyAllowanceProposalWorkflowTableData } from '~/data/proposals/useGetLegacyProposalWorkflows';

import { useAllowanceProposalColumns } from '../../../../common';
import {
  ProposalWorkflowTablePropsType,
  ProposalsWorkflowTableLayout,
} from '../common';

export const AllowanceProposalWorkflowTable = (
  props: ProposalWorkflowTablePropsType,
) => {
  const columns = useAllowanceProposalColumns();
  const { data: rows } = useLegacyAllowanceProposalWorkflowTableData(props);
  return <ProposalsWorkflowTableLayout rows={rows} columns={columns} />;
};
